export class ChangePassword {

    userId: number;
    oldPassword: string;
    newPassword: string;
    token: string;

}
